import { Box } from '@mantine/core';
import { memo, useState } from 'react';
import { Text } from '../../../ui-library/typography/typography';

export const TruncatedText = memo(
  ({
    text,
    maxLength = 100,
    onToggle,
    textSize = 'small',
  }: {
    text: string;
    maxLength?: number;
    textSize?: 'tiny' | 'small' | 'medium' | 'large' | 'regular';
    onToggle?: (isExpanded: boolean) => void;
  }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const shouldTruncate = text && text.length > 0 && text.length > maxLength;
    const displayText = isExpanded || !shouldTruncate ? text : `${text.slice(0, maxLength)}...`;

    const handleClick = () => {
      if (shouldTruncate) {
        setIsExpanded(!isExpanded);
        onToggle?.(!isExpanded);
      }
    };

    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 8,
          cursor: shouldTruncate ? 'pointer' : 'default',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        }}
        onClick={handleClick}
      >
        <Text size={textSize} style={{ width: '100%' }}>
          {displayText}
        </Text>
      </Box>
    );
  },
);

TruncatedText.displayName = 'TruncatedText';
